



















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import { Validator } from "vee-validate";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: {
    Button,
    Input,
  }
})
export default class LinkedAccountVerificationUmb extends Vue {
  $validator: Validator;

  @Prop()
  linkedBankAccountId: number;

  bankAccountStore = useBankAccountStore();

  pennyTransaction1 = 0;
  pennyTransaction2 = 0;

  onCancelClick () {
    this.exit();
  }

  onVerifyBankAccount () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      this.bankAccountStore.verifyLinkedAccount({
        linkedBankAccountId: this.linkedBankAccountId,
        verifyAmount1: this.pennyTransaction1,
        verifyAmount2: this.pennyTransaction2
      });
      this.exit();
    });
  }

  exit () {
    this.$emit("verifyExitClicked", true);
  }
}
